/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-04-19 15:57:29
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-20 21:18:14
 */
import request from '../../utils/request'
import server from './config'
export default {
  /**
   * 退款详情
   */
  getRefundInfoByOrderId:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/refund/1/getRefundInfoByOrderId`,
      method: 'post',
      data
    })
  },
  getRefundStatusByRecordId:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/refund/1/getRefundStatusByRecordId`,
      method: 'post',
      data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/modules/refund.js